module.exports = __webpack_public_path__ + "img/a-banner.7cb05363.png";